<template>
  <base-layout>
    <h1 slot="header" class="text-green text-uppercase">
      {{ patient.first_name }} {{ patient.last_name }}, <span class="">{{ getAge() }}</span>
    </h1>
    <template v-slot:buttons>
      <icon-button
          icon="arrow_back"
          color="#3c8dbc"
          @click="back"
          :tooltip="{left: true, bottom: false, attach: false}"
      >
        {{ 'app.back' | trans}}
      </icon-button>
      <icon-button
          :permission="hasPermission('patient_delete')"
          :tooltip="{left: true, bottom: false, attach: false}"
          icon="delete"
          color="error"
          @click="removePatient"
      >
        {{ 'app.remove_patient' | trans}}
      </icon-button>
    </template>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
        <v-tab>
          {{ `app.patients.panel.information` | trans }}
          <v-icon>info</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.panel.interview` | trans }}
          <v-icon>monitor_heart</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.panel.measurement` | trans }}
          <v-icon>balance</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.panel.menu` | trans }}
          <v-icon>calendar_today</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.panel.note` | trans }}
          <v-icon>note</v-icon>
        </v-tab>
        <v-tab v-if="hasPermission('patient_mobile_app_invite')">
          {{ `app.patients.panel.mobile_app` | trans }}
          <div class="d-flex align-items-center justify-content-center">
            <v-icon>install_mobile</v-icon>
            <small class="label bg-green text-lowercase ml-2 mb-1">nowość</small>
          </div>
        </v-tab>
        <v-tab v-else :disabled="true" v-tooltip="{
          content: trans('app.no_access_tooltip'),
          delay: { show: 500, hide: 2000 },
          autoHide: false,
        }">
          {{ `app.patients.panel.mobile_app` | trans }}
          <v-icon>install_mobile</v-icon>
        </v-tab>
        <v-tab-item :key="`information`">
          <patient-information></patient-information>
        </v-tab-item>
        <v-tab-item :key="`interview`">
          <interview-page :patient-id="patientId" :interview-id="interviewId"></interview-page>
        </v-tab-item>
        <v-tab-item :key="`measurement`">
          <measurements :patient_id="patientId"></measurements>
        </v-tab-item>
        <v-tab-item :key="`menu`">
          <menu-page :patient_id="patientId" :menu-saved="menuSaved"></menu-page>
        </v-tab-item>
        <v-tab-item :key="`note`">
          <note :patient_id="patientId"></note>
        </v-tab-item>
        <v-tab-item :key="`mobile_app`" v-if="hasPermission('patient_mobile_app_invite')">
          <mobile-invite-page :patient_id="patientId"></mobile-invite-page>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import {trans} from "../../app";
import {polishPlurals} from "polish-plurals";

export default {
  props: {
    tab: Number,
    patientId: {
      type: Number,
      required: true,
    },
    interviewId: {
      type: Number,
      required: false,
      default: null
    },
    menuSaved: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    selectedTab: 0,
  }),
  async mounted() {
    await this.fetchPatient(this.patientId);
    this.selectedTab = this.tab;
    this.$root.$on('measurementStored', async () => {
      await this.fetchPatient(this.patientId);
    });
    this.$root.$on('measurementDeleted', async () => {
      await this.fetchPatient(this.patientId);
    });
  },
  methods: {
    ...mapActions(['fetchPatient', 'deletePatient']),
    removePatient() {
      this.$confirmDanger(
          trans('app.confirm_patient_removal', {name: `${this.patient.first_name} ${this.patient.last_name}`}),
          trans('app.remove_patient')
      ).then(async () => {
        await this.deletePatient(this.patientId);
        window.location = '/patients';
      }).catch((error) => {
        this.sentryCaptureException(error);
      })
    },
    async back() {
      window.location = '/patients';
    },
    getAge() {
      const years = polishPlurals(
          trans('app.year'),
          trans('app.years'),
          trans('app.years_genitive'),
          this.patient.age
      );
      return `${this.patient.age} ${years}`;
    },
  },
  computed: {
    ...mapGetters(['patient', 'hasPermission'])
  },
}
</script>
